export default __webpack_public_path__ + "static/media/landing-video.6c93b669.mp4";